import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';

import WaveBanner from '../../elements/wave-banner';
import CollectionCards from '../../elements/collection-cards';
import SimpleSplitSection from '../../elements/simple-split-section';
import ContactForm from '../../elements/contact-form';
import IconSection from '../../elements/icon-section';
import WeddingSlider from './wedding-slider';
import WeddingBanner from './wedding-banner';
import FeaturedCollectionRows from '../featured/featured-collection-rows';
import ImageFeed from '../../elements/image-feed';

import { media } from '../../helpers';

// TODO: Make Image Feed dynamic

const WeddingCategoryContainer = styled.div`
    .slider-outer-container {
        top: -10vh;
        margin-bottom: -10vh;

        position: relative;
        ${media.small`top: -15vh; margin-bottom: -15vh;`}
    }

    .contact-form-outer-container {
        margin-bottom: 40px;
        ${media.large`margin-bottom: 0px;`}
    }
`;

const WeddingCategory = () => {
    const data = useStaticQuery(graphql`
        query {
            allWpPage(filter: { title: { eq: "Weddings" } }) {
                edges {
                    node {
                        weddings_page_acf {
                            weddingBanner {
                                bannerBgColor
                                bannerCaption
                                bannerHeadline
                            }
                            weddingSlider {
                                slideImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1400) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                slideTitle
                                slideButton {
                                    title
                                    url
                                }
                                slideCaption
                            }
                            weddingCards {
                                cardLink {
                                    title
                                    url
                                }
                                cardImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 650) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                hoverText
                                overlayColor
                            }
                            bannerCta {
                                bannerHeadline
                                bannerButton {
                                    target
                                    title
                                    url
                                }
                                bannerImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 1920) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }

                            weddingCollectionRows {
                                rows {
                                    collectionDescription
                                    collectionHandle
                                    collectionTitle
                                    collectionImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 1200) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            iconSection {
                                icons {
                                    iconCaption
                                    iconImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 100) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                }
                                largeButton {
                                    title
                                    url
                                }
                                smallButton {
                                    title
                                    url
                                }
                                footerCaption
                            }
                            imageFeed {
                                sectionTitle
                                images {
                                    image {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 650) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            splitSectionSettings1 {
                                rows {
                                    contentRowImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 1000) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                    contentRowContent
                                    contentRowTitle
                                    contentRowLinks {
                                        link {
                                            title
                                            url
                                        }
                                    }
                                    contentRowButton {
                                        title
                                        url
                                    }
                                }
                            }
                            splitSectionSettings2 {
                                rows {
                                    contentRowImage {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 1000) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                    contentRowContent
                                    contentRowTitle
                                    contentRowLinks {
                                        link {
                                            title
                                            url
                                        }
                                    }
                                    contentRowButton {
                                        title
                                        url
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const page = (data && data.allWpPage.edges[0].node) || '';
    const {
        weddingBanner,
        weddingSlider,
        weddingCards,
        iconSection,
        splitSectionSettings1,
        splitSectionSettings2,
        weddingCollectionRows,
        bannerCta,
    } = page.weddings_page_acf || {};
    return (
        <WeddingCategoryContainer>
            <WaveBanner content={weddingBanner} />
            <div className="slider-outer-container">
                <WeddingSlider rows={weddingSlider} />
            </div>
            <CollectionCards cards={weddingCards} />
            <IconSection content={iconSection} icons={iconSection.icons} />
            <SimpleSplitSection rows={splitSectionSettings1.rows} />
            <div className="contact-form-outer-container">
                <ContactForm />
            </div>
            <SimpleSplitSection rows={splitSectionSettings2.rows} />
            <FeaturedCollectionRows rows={weddingCollectionRows.rows} />
            <WeddingBanner content={bannerCta} />
            <ImageFeed />
        </WeddingCategoryContainer>
    );
};

export default WeddingCategory;
